import React from 'react';
import {Box, Container, Paper} from '@material-ui/core';
import {useLocation, useRouteMatch} from 'react-router-dom';
import {Routing, TabPanel} from 'layouts/commons';
import {blankClasses, BlankStyles} from 'assets/tss/layouts/blank';
import {demoRoutes} from './routes';

function Blank() {
    const classes = BlankStyles();
    const match = useRouteMatch();
    const location = useLocation();
    const isHome = location.pathname === '/blank' && match.isExact;

    return (
        <Container component='main' disableGutters>
            {!isHome && (
                <TabPanel path={location.pathname} routes={demoRoutes} />
            )}
            <Box sx={blankClasses}>
                <Paper elevation={2} square className={classes.root}>
                    <Routing routes={demoRoutes} />
                </Paper>
            </Box>
        </Container>
    );
}

export default Blank;
